/* eslint-disable import/no-default-export */
import BaseEngine, { EngineEvents } from './base';

export default class AjaxEngine extends BaseEngine {
  tryRequest: BaseEngine['tryRequest'] = (
    request: Request,
    events: EngineEvents,
  ): Promise<ApiRawResponse> => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();

      // We want to treat the response like text, since that's what the base
      // engine expects
      xhr.responseType = 'text';

      xhr.onload = async () => {
        return resolve({
          statusCode: xhr.status,
          contentType: xhr.getResponseHeader('content-type'),
          body: xhr.response,
        });
      };

      xhr.onerror = async () => {
        resolve(this.NETWORK_ERROR);
      };

      if (events && events.onprogress) {
        xhr.onprogress = events.onprogress;
      }

      xhr.open(request.method, request.url, true);

      if (request.headers) {
        Object.entries(request.headers).forEach(([key, value]) =>
          xhr.setRequestHeader(key, value),
        );
      }

      xhr.send();
    });
  };
}
